/* eslint-disable */
import React from 'react';
import ROUTES from 'config/routes';
import COMPANY_DATA from 'config/companyData';
import { StyledDiv, Header } from '../styled';
import Email from 'shared/components/Email';

const { COMPANY_NAME, RODO_EMAIL, COMPANY_STREET, COMPANY_ZIP_CODE, BOK_EMAIL, PRIVACY_POLICY_LAST_UPDATE } =
  COMPANY_DATA;

function PrivacyPolicyPl() {
  const [show, setShow] = React.useState(false);
  return (
    <>
      <StyledDiv>
        <StyledDiv>
          <Header>Polityka prywatności</Header>
        </StyledDiv>
        <StyledDiv>
          <p>
            Właścicielem serwisu internetowego TrustMate.io znajdującego się pod adresem URL https://trustmate.io (dalej
            jako „Serwis”) i narzędzia do zarządzania opiniami TrustMate.io jest {COMPANY_NAME}. Niniejszy dokument,
            zgodnie z “Ogólnym rozporządzeniem o ochronie danych” (RODO) i wszystkimi obowiązującymi przepisami prawa
            opisuje, w jaki sposób Twoje dane osobowe będą używane w serwisie https://trustmate.io w celach związanych z
            informowaniem o naszych usługach, wyświetlaniem strony internetowej oraz jej utrzymywaniem, usprawnianiem i
            zarządzaniem w celu zapewnienia najwyższego komfortu korzystania z naszych usług przy każdej interakcji z
            nami w świecie cyfrowym.{' '}
          </p>
          <p>
            W tym miejscu dowiesz się z jakich narzędzi służących do celów marketingowych, gromadzenia i budowania
            statystyk stron internetowych, plików cookies, wtyczkek, beaconów, pixeli, tagów, skryptów, korzystamy na
            naszej stronie internetowej oraz jak one działają i w jaki sposób możes wnieść sprzeciw wobec przetwarzania
            Twoich danych osobowych, a także, jak możesz usunąć zebrane dane.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Administrator danych TrustMate S.A.</h3>
          <p>
            Na stronie internetowej https://trustmate.io Twoje informacje będą przetwarzane przez firmę {COMPANY_NAME},
            która jest administratorem niniejszej strony.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Kontakt w sprawie danych osobowych</h3>
          <p>
            Osobą dedykowaną do spraw danych osobowych jest inspektor danych osobowych - jest to osoba, z którą możesz
            się kontaktować we wszystkich sprawach związanych z przetwarzaniem Twoich danych osobowych oraz realizacją
            uprawnień związanych z ich przetwarzaniem.
          </p>
          <div>
            Dane kontaktowe naszego Inspektora Ochrony Danych{' '}
            <Email email={RODO_EMAIL} setVisible={setShow} visible={show} /> lub
            <address>
              <div>{COMPANY_NAME}</div>
              <div>{COMPANY_STREET}</div>
              <div>{COMPANY_ZIP_CODE}</div>
            </address>
            <div>Prosimy o umieszczenie na kopercie dopisku „RODO”</div>
          </div>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Dane Osobowe</h2>
        </StyledDiv>
        <StyledDiv>
          <h3>Jakie dane osobowe zbieramy na Twój temat i co z nimi robimy?</h3>
          <ol>
            <li>
              <b>Dane identyfikacyjne</b> - to informacje, z których korzystamy do identyfikowania użytkownika i
              sprawdzania tożsamości. Obejmują one: imię, adres e-mail, unikalny numer klienta, pseudonim, hasło,
              identyfikatory serwisów społecznościowych
            </li>
            <li>
              <b>Dane kontaktowe</b> - są to dane, z których korzystamy, aby się z Tobą kontaktować w celu udostępniania
              informacji promocyjnych, świadczenia usług, udostępniania aktualności na nasz temat oraz udzielania
              odpowiedzi na Twoje pytania. Obejmują one na przykład: numer telefonu, adres rozliczeniowy, adres e-mail,
              identyfikator Messenger ID oraz imię w serwisach społecznościowych
            </li>
            <li>
              <b>Informacje na temat zakupu</b> - są to informacje, z których korzystamy w celach związanych z
              przetwarzaniem zamówienia partnerów. Obejmują one m.in. zawartość koszyka, dane dostawy, adres wysyłki i
              adres rozliczeniowy, numer zamówienia partnera oraz historię zakupów w TrustMate SA
            </li>
            <li>
              <b>Informacje z serwisów społecznościowych</b> - są to informacje, z których korzystamy, aby lepiej Ciebie
              zrozumieć w celu budowania lepszych relacji oraz koncentrowania naszych działań marketingowych na
              wiadomościach, które będą dla Ciebie przydatne i interesujące (na podstawie Twoich zachowań online) oraz
              ułatwiania interakcji prowadzonych za pośrednictwem serwisów społecznościowych. Obejmuje to wszystkie
              ogólnodostępne informacje z serwisów społecznościowych, m.in. nazwy użytkownika w serwisach
              społecznościowych, interakcje i posty w serwisach społecznościowych, “polubienia” i inne reakcje, osoby, z
              którymi jesteś powiązany/-na w serwisach społecznościowych. Te informacje udostępniane są nam pośrednio
              lub bezpośrednio przez serwisy społecznościowe (np. Facebook) za pośrednictwem pośredników, z którymi
              jesteśmy związani umowami
            </li>
            <li>
              <b>Informacje o urządzeniu</b> - są to informacje, z których korzystamy, aby zabezpieczać naszą sieć i
              poprawiać nasze usługi oraz wydajność. Obejmują one na przykład: adres IP, datę i czas wizyty, czas
              przebywania na naszej stronie internetowej, odsyłający adres URL (w przypadku przejścia użytkownika na
              naszą stronę z innej strony lub za pośrednictwem reklamy), odwiedzane podstrony naszej strony
              internetowej, rodzaj przeglądarki internetowej, rodzaj urządzenia i ich wersje oraz system operacyjny
            </li>
            <li>
              <b>Korespondencja</b> - są to informacje, które wykorzystujemy w celach związanych z kontrolą jakości oraz
              aby zrealizować Twoje wnioski lub zachować zgodność z wymogami prawnymi. Obejmują one na przykład:
              nagrania połączeń telefonicznych nawiązywanych przez użytkowników z Biurem Obsługi Klienta lub odwrotnie,
              korespondencję e-mail prowadzoną z personelem TrustMate SA oraz korespondencję pocztową z personelem
              TrustMate SA.
            </li>
          </ol>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Cele</h2>
        </StyledDiv>
        <StyledDiv>
          <h3>Dlaczego korzystamy z danych osobowych</h3>
          <p>
            Korzystamy z danych osobowych, aby zapewniać najlepszą możliwą jakość usług oraz nieustannie pracujemy nad
            jej poprawą.
          </p>
          <p>W szczególności korzystamy z danych osobowych w takich celach jak:</p>
          <ol>
            <li>
              <b>Sprzedaż naszych produktów i usług</b> - korzystamy z danych osobowych, aby przetwarzać zamówioną przez
              Ciebie usługę, sprawdzać otrzymaną przez nas płatność, dbać o zgodność z wymaganiami naszych Warunków
              (dotyczących sprzedawania produktów), dostarczać zamówione produkty
            </li>
            <li>
              <b>
                Korzystamy z danych osobowych, aby przetwarzać zamówioną przez Ciebie usługę, sprawdzać otrzymaną przez
                nas płatność, dbać o zgodność z wymaganiami naszych Warunków (dotyczących sprzedawania produktów),
                dostarczać zamówione produkty
              </b>{' '}
              - gromadzimy i przechowujemy pewne informacje pochodzące od użytkowników z urządzeń, z urządzeń końcowych
              i przeglądarek internetowych (m.in. korzystając z plików cookie, znaczników pikselowych lub innych
              rozwiązań technicznych do targetowania). Umożliwia to nam zapamiętywanie preferencji użytkowników
              dotyczących przeglądania naszych stron internetowych i robienia na nich zakupów. Umożliwia nam to również
              przekazywanie odpowiednich informacji dopasowanych do potrzeb użytkowników. Więcej informacji na temat
              tego, jak korzystamy z technologii śledzących online, takich jak pliki cookie, znaczniki i inne rodzaje
              kodu, znajdziesz w sekcji zatytułowanej “Pliki cookie”
            </li>
            <li>
              <b>Przechowywanie danych osobowych</b> - będziemy przechowywać dane osobowe użytkowników do momentu
              wpłynięcia wniosku o ich usunięcie lub okresu wymaganego przez prawo
            </li>
            <li>
              <b>Oferowanie, poprawianie i zarządzanie naszymi produktami i usługami</b> - podejmujemy odpowiednie kroki
              techniczne i organizacyjne w celu ochrony danych osobowych przed przypadkowym lub nielegalnym zniszczeniem
              bądź przypadkową utratą, modyfikacją, nieupoważnionym wykorzystaniem, ujawnieniem lub dostępem
              (szczególnie gdy przetwarzanie obejmuje przekazywanie danych) oraz przed wszystkimi innymi nielegalnymi
              rodzajami przetwarzania i niewłaściwego użytkowania
            </li>
            <li>
              <b>Informowanie o produktach i usługach</b> - korzystamy z danych osobowych użytkowników, aby wysyłać
              powiadomienia i aktualności dotyczące naszych produktów i usług na podstawie preferencji, zainteresowań,
              uczestnictwa i społeczności naszych użytkowników. Jest to traktowane jako “uzasadniony interes
              gospodarczy” mający na celu zadbanie, by nasze przedsiębiorstwo prosperowało
            </li>
            <li>
              <b>Ochrona naszych produktów i usług</b> - będziemy mogli dalej prosperować jako przedsiębiorstwo, jeśli
              będziemy stanowczo bronić naszych interesów korporacyjnych i gospodarczych. Obejmuje to dbanie, by
              zamówienia i opłaty były legalne (zapobieganie oszustwom). Jest to traktowane jako “uzasadniony interes
              gospodarczy” mający na celu zadbanie, by nasze przedsiębiorstwo prosperowało
            </li>
            <li>
              <b>Opieka nad produktami i usługami</b> - korzystamy z danych użytkowników, by prowadzić ich konta w
              serwisie https://trustmate.io. Twoje konto będzie głównie stosowane w celach związanych ze świadczeniem
              usług zgodnych z{' '}
              <a href={ROUTES.USER_REGULATIONS}>
                <b>regulaminem TrustMate dla użytkowników</b>
              </a>{' '}
              oraz{' '}
              <a href={ROUTES.BUSINESS_REGULATIONS}>
                <b>regulaminem TrustMate dla partnerów</b>
              </a>
            </li>
          </ol>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Komu udostępniamy Twoje dane osobowe?</h2>
        </StyledDiv>
        <StyledDiv>
          <p>
            W poczuciu odpowiedzialności obywatelskiej możemy być zmuszeni do udostępnienia danych następującym rodzajom
            podmiotów (w zakresie dopuszczalnym i wymaganym przez prawo):
          </p>
          <ol>
            <li>
              <b>Władze i organy ścigania</b> - przedstawiciele władz rządowych i/lub organów ścigania, w przypadku, gdy
              jest to konieczne w celach określonych w niniejszych informacjach, jeśli jest to wymagane w świetle prawa
              lub wymagane do ochrony prawnej naszych uzasadnionych interesów zgodnie z obowiązującymi przepisami prawa
            </li>
            <li>
              <b>Partnerzy</b> - możemy prowadzić wspólne programy, wydarzenia lub promocje wraz z innymi firmami na ich
              stronach internetowych lub w ich aplikacjach. Nasi partnerzy będą korzystać z danych osobowych
              użytkowników, wyłącznie jeśli wyrażą na to zgodę. Jeśli nie życzysz sobie, aby Twoje dane osobowe były
              gromadzone lub udostępniane innym spółkom niż {COMPANY_NAME}, możesz nie uczestniczyć w takich programach,
              promocjach lub wydarzeniach
            </li>
            <li>
              <b>Doradca potencjalnego nabywcy</b> - jeśli nasze przedsiębiorstwo zostanie sprzedane lub połączone z
              innym przedsiębiorstwem, Twoje dane osobowe zostaną ujawnione naszym doradcom, wszystkim doradcom
              potencjalnego nabywcy oraz nowemu właścicielowi przedsiębiorstwa
            </li>
            <li>
              <b>Zewnętrznym usługodawcom przetwarzającym</b> - dane osobowe w imieniu TrustMate SA, na przykład na
              potrzeby przetwarzania danych związanych z kartami kredytowymi i płatnościami, przechowywaniem (hosting
              danych), zarządzaniem i obsługą danych, dystrybucją poczty elektronicznej, pracami badawczo-analitycznymi,
              a także zarządzaniem marką, promocjami produktowymi oraz administracją wybranych usług i funkcji.
              Korzystając z usług świadczonych przez dostawców będących osobami trzecimi, zawieramy umowy zobowiązujące
              ich do wdrożenia stosownych środków technicznych i organizacyjnych w celu ochrony danych osobowych
              użytkowników
            </li>
          </ol>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Na jakich podstawach prawnych dane osobowe sa przez nas wykorzystywane</h2>
          <ol>
            <li>
              <b>Zgoda</b> - gdy użytkownik odwiedza serwis https://trustmate.io, rejestruje się, kupuje produkt,
              wystawia opinię, bierze udział w mediacji, uczestniczy w życiu naszej społeczności lub zakłada konto,
              wyraża zgodę na korzystanie przez nas z udostępnionych przez siebie danych osobowych w określonych celach
              zgodnie z tymi Informacjami. Przechowujemy zgody na korzystanie z danych osobowych w szczególny sposób
            </li>
            <li>
              <b>Zgodność z przepisami prawa</b> - przetwarzamy i korzystamy z danych osobowych użytkowników w celu
              wywiązywania się ze zobowiązań prawnych wynikających z obowiązujących przepisów prawa
            </li>
            <li>
              <b>Zobowiązania umowne</b> - przetwarzamy dane osobowe użytkowników i korzystamy z nich w celu
              wywiązywania się z naszych zobowiązań umownych, aby móc dostarczać użytkownikom zamawiane produkty i
              usługi
            </li>
            <li>
              <b>Uzasadniony interes</b> - będziemy przetwarzać dane osobowe użytkowników i z nich korzystać, aby
              dostarczać i usprawniać nasze produkty i usługi, wysyłając korespondencję marketingową oraz
              kwestionariusze badawczo-rozwojowe
            </li>
          </ol>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Twoje prawa i jak mozna je egzekwować?</h2>
          <p>
            Jako konsument zamieszkały w Polsce masz następujące prawa dotyczące danych osobowych na mocy RODO. Musisz
            jednak wiedzieć, że będziemy stosować się do niego w zakresie, w jakim jest to od nas wymagane. W niektórych
            przypadkach, gdy prawo wymaga od nas zachowania Twoich danych w niezmienionej postaci, odrzucimy Twój
            wniosek. W tym przypadku uzasadnimy naszą decyzję.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Dostęp do danych osobowych</h3>
        </StyledDiv>
        <StyledDiv>
          <p>Masz prawo do ubiegania się o dostęp do swoich danych osobowych. W tym do informacji o tym:</p>
          <ol type="a">
            <li>dlaczego przechowujemy Twoje dane osobowe</li>
            <li>jakich kategorii dane osobowe przechowujemy</li>
            <li>co robimy z Twoimi danymi osobowymi</li>
            <li>kto ma dostęp do Twoich danych osobowych (i gdzie ten podmiot się znajduje)</li>
            <li>gdzie Twoje dane osobowe mogą zostać przekazane</li>
            <li>jak długo przechowujemy Twoje dane osobowe</li>
            <li>jeśli nie udostępniłeś/-aś nam swoich danych osobowych bezpośrednio, jak je uzyskaliśmy</li>
            <li>jakie masz prawa na mocy obowiązujących przepisów</li>
            <li>czy korzystamy z Twoich danych osobowych w celu automatycznego podejmowania decyzji i jak to robimy</li>
          </ol>
          <p>
            Jeśli chcesz uzyskać kopię swoich danych osobowych, które przechowujemy prosimy złożyć wniosek mailowo na
            adres: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
          </p>
        </StyledDiv>
        <StyledDiv>
          <p>
            <b>Korekta swoich danych osobowych </b>– masz prawo do sprawdzenia, czy dane osobowe są prawidłowe i
            kompletne. Jeśli masz konto w serwisie, prosimy o zalogowanie się na nie i wprowadzenie wymaganych zmian.
            Jeśli potrzebujesz dalszej pomocy, prosimy o kontakt z naszym Biurem Obsługi Klienta, pisząc na adres{' '}
            <Email email={BOK_EMAIL} setVisible={setShow} visible={show} />
          </p>
          <p>
            <b>Przenośność danych </b>– masz prawo do uzyskania kopii swoich danych osobowych w celu przekazania ich
            innej firmie, w tym celu prosimy o wniosek na adres:{' '}
            <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
          </p>
          <p>
            <b>Wnoszenie skargi do organu regulacyjnego/nadzorczego </b>- jeśli nie jesteś zadowolony/-na ze sposobu, w
            jaki zastosowaliśmy się do praw konsumenta lub naszych “Zasad prywatności”, masz prawo do wniesienia skargi
            do organu nadzorczego w kraju członkowskim Unii Europejskiej, w którym się znajdujesz
          </p>
          <p>
            <b>Usuwanie danych osobowych w TrustMate SA</b>
            jeśli nie chcesz mieć już z nami kontaktu lub nie chcesz, abyśmy przechowywali należące do Ciebie dane
            osobowe, przysługuje Ci prawo zwrócenia się do nas o usunięcie wszystkich danych osobowych związanych z Tobą
            z naszych systemów. W tym celu prosimy o przesłanie wniosku mailowo na adres:{' '}
            <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />. Prosimy pamiętać jednak o tym, że mogą
            istnieć pewne zobowiązania prawne, które mogą nas zmusić do odrzucenia wniosku lub zachowania pewnych
            informacji
          </p>
          <p>
            <b>Ograniczanie sposobów, w jakie korzystamy z Twoich danych osobowych i je przetwarzamy </b>– masz również
            prawo zwrócić się od nas o zaprzestanie korzystania z Twoich danych osobowych w określony sposób (np. jeśli
            nie chcesz, abyśmy profilowali dane w celach marketingowych lub wysyłali Ci wiadomości marketingowe). W tym
            celu prosimy o przesłanie wniosku mailowo na adres:{' '}
            <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />
          </p>
          <p>
            W razie pytań, obaw lub skarg związanych z prawami dotyczącymi prywatności danych osobowych prosimy o
            kontakt pod adresem: <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />.
          </p>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Pytania i skargi dotyczące danych osobowych?</h2>
        </StyledDiv>
        <StyledDiv>
          <p>
            Możesz skontaktować się z Inspektorem Ochrony Danych pod adresem:{' '}
            <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />.
          </p>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Zakres danych osobowych przetwarzanych na TrustMate.io</h2>
        </StyledDiv>
        <StyledDiv>
          <ol>
            <li>
              <h3>Odwiedzanie serwisu - raporty</h3>
              <p>
                Kiedy otwierasz naszą stronę internetową, https://trustmate.io zbiera tzw. dane eksploatacyjne, w tym
                adres IP, i zapisuje jest w postaci logów. W logu zapisane zostają również: nazwa wyświetlonej strony,
                pobierane pliki, data i godzina pobrania, ilość przesłanych danych, notyfikacja o pomyślnym pobraniu,
                typ przeglądarki wraz z jej wersją, system operacyjny, tzw. referrery URL (wcześniej odwiedzona strona)
                oraz wzywający dostawca. Zidentyfikowanie Ciebie na podstawie tych danych nie jest możliwe.
              </p>
              <p>
                Podczas odwiedzin na naszej stronie, na urządzeniu końcowym (laptopie, tablecie, smartfonie lub PC)
                zapisywane są pliki cookies. Szczegóły dotyczące plików cookies używanych na naszej stronie
                internetowej, celu ich stosowania oraz opis, jak usunąć pliki cookies, znajdziesz w dalszej części
                polityki dotyczącej cookies.
              </p>
              <p>
                Zbieramy logi, w tym adresy IP, aby zapewnić użytkownikom sprawne połączenie i wygodne korzystanie z
                naszej strony. Logi zbierane są również w celu oceny zabezpieczeń i stabilności systemu oraz w celach
                administracyjnych. Pliki cookies dają nam możliwość stworzenia serwisu i strony internetowej, które są
                bardziej przyjazne użytkownikowi, dzięki m.in. możliwości stwierdzenia, czy dany użytkownik odwiedzał
                już którąś z naszych stron. Za pomocą plików cookies otrzymujemy również informacje dotyczące zachowania
                użytkownika na naszej stronie internetowej oraz informacje dotyczące wyszukiwanych fraz, które
                doprowadziły użytkowników do naszej strony internetowej.
              </p>
              <p>
                Dane zawarte w logach, w tym adres IP, służą jedynie zoptymalizowaniu technicznemu oraz optymalizacji
                ustawień na naszej stronie internetowej oraz ochronie naszych systemów (np. w przypadku cyberataku bądź
                incydentu związanego z zabezpieczeniem systemu). Podczas uruchamiania naszej strony nie jest możliwe
                zidentyfikowanie osoby na podstawie danych z loga, w tym adresu IP. Identyfikacja jest możliwa tylko
                wtedy, jeśli jednocześnie zalogujesz się na swoim koncie klienta. W tym przypadku jesteśmy w stanie
                przyporządkować adres IP do użytkownika. Dzięki plikom cookies możemy się np. dowiedzieć, czy i w jakim
                celu odwiedzałeś/-aś nasze strony, oraz czy rejestrowałeś/-aś się u nas używając konkretnego ID, a także
                kiedy korzystałeś/-aś ponownie z tego ID.
              </p>
              <p>
                Za hosting naszej strony internetowej oraz wszystkich danych odpowiada wewnętrzne centrum przetwarzania
                danych oraz zewnętrzni dostawcy.
              </p>
            </li>
          </ol>
          <table>
            <thead>
              <tr>
                <th>Dostawca</th>
                <th>Cel przetwarzania danych</th>
                <th>Dane dostawcy & polityka prywatności</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>Amazon Webservices Inc.</div>
                  <div>410 Terry Drive Ave North</div>
                  <div>WA 98109-5210 Seattle, USA</div>
                </td>
                <td>
                  Hosting i backup Przetwarzanie danych ma miejsce wyłącznie w centrach przetwarzania danych Amazon Web
                  Services z siedzibą w Europie.
                </td>
                <td>
                  <div>
                    <a href="https://aws.amazon.com/de/data-protection/">https://aws.amazon.com/de/data-protection/</a>
                  </div>
                  <div>
                    <a href="https://aws.amazon.com/en/compliance/eu-data-protection/">
                      https://aws.amazon.com/en/compliance/eu-data-protection/
                    </a>
                  </div>
                  <div>
                    <a href="https://aws.amazon.com/en/compliance/data-center/data-centers/">
                      https://aws.amazon.com/en/compliance/data-center/data-centers/
                    </a>
                  </div>
                  <div>
                    <a href="https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4&status=Active">
                      https://www.privacyshield.gov/participant?id=a2zt0000000TOWQAA4&status=Active
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <b>Okres przechowywania danych: </b>
            Logi, włącznie z adresem IP, są automatycznie usuwane po okresie sześciu (6) miesięcy od momentu ich
            zebrania. Do tego czasu adres IP zostaje zanonimizowany i zapisany jedynie w celach administracyjnych
            (technicznych).
          </div>
          <div>
            <b>Podstawa prawna: </b>
            Art. 6 ust. 1 lit. f) RODO
          </div>
          <div>
            <b>Ustawowy lub umowny wymóg podania danych osobowych: </b>
            Podanie ww. danych osobowych nie jest wymogiem ustawowym ani umownym. Jednak bez adresu IP oraz plików
            cookies usługi i działanie naszej strony nie mogą być zagwarantowane, a poszczególne aplikacje i usługi mogą
            nie być dostępne, bądź działać w sposób ograniczony.
          </div>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Odwiedzanie https://trustmate.io - analiza stron internetowych</h2>
        </StyledDiv>
        <StyledDiv>
          <p>
            Używamy na naszej stronie tzw. narzędzi śledzących oraz narzędzi do statystyk internetowych. Zbieranie
            danych dostępu na naszej stronie internetowej oraz badanie zachowań użytkowników służy optymalizacji naszej
            oferty i poprawy jakości serwisu.
          </p>
          <p>
            Narzędzia te badają, w jaki sposób i z jakiego miejsca użytkownicy trafiają na naszą stronę internetową,
            które obszary naszej strony są popularniejsze od innych oraz jak często i jak długo poszczególne podstrony i
            kategorie są oglądane. Możemy również określić, jakich fraz użytkownicy szukali oraz jakie strony
            odwiedzali, a także ocenić, ilu użytkowników w sumie odwiedziło naszą stronę oraz które informacje i oferty
            są najbardziej popularne. Celem jest stworzenie przyjaznej użytkownikowi oferty i prezencji internetowej za
            pomocą zebranych informacji.
          </p>
          <p>
            Przez analizę statystyczną profili użytkowników możemy stworzyć obraz funkcjonalności i popularności naszej
            strony internetowej. Dotyczy to analizy częstotliwości odwiedzania stron z konkretną grupą wizytówek oraz
            liczby odwiedzających.
          </p>
          <p>
            Następujący dostawcy narzędzi śledzących i narzędzi do tworzenia statystyk stron internetowych przetwarzają
            dane dostępu w naszym imieniu, aby przeprowadzić analizę użytkownika oraz przygotować dla nas statystyki. W
            tym celu zawarliśmy z dostawcami umowę powierzenia przetwarzania danych osobowych.
          </p>
          <table>
            <thead>
              <tr>
                <th>Dostawca</th>
                <th>Narzędzie</th>
                <th>Dane dostawcy & polityka prywatności</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>Google Inc.</div>
                  <div>1600 Amphitheatre Parkway</div>
                  <div>Mountain View, CA 94043</div>
                  <div>USA</div>
                </td>
                <td>Google Analytics</td>
                <td>
                  <div>
                    <a href="www.google.com/policies/">www.google.com/policies/</a>
                  </div>
                  <div>
                    <a href="https://support.google.com/analytics/answer/6004245?hl=en">
                      https://support.google.com/analytics/answer/6004245?hl=en
                    </a>
                  </div>
                  <div>
                    <a href="https://www.privacyshield.gov/participant">Privacy shield</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </StyledDiv>
        <StyledDiv>
          <p>
            <b>Okres przechowywania danych: </b>
            Następujący dostawcy narzędzi śledzących i narzędzi do tworzenia statystyk stron internetowych przetwarzają
            dane dostępu w naszym imieniu, aby przeprowadzić analizę użytkownika oraz przygotować dla nas statystyki. W
            tym celu zawarliśmy z dostawcami umowę powierzenia przetwarzania danych osobowych.
          </p>
          <p>
            <b>Podstawa prawna: </b>
            Art. 6 ust. 1 lit. f) RODO
          </p>
          <p>
            <b>Ustawowy bądź umowny wymóg podania danych osobowych: </b>
            Podanie ww. danych osobowych nie jest wymogiem ustawowym ani umownym.
          </p>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Odwiedzanie https://trustmate.io - reklama</h2>
        </StyledDiv>
        <StyledDiv>
          <p>
            Strona internetowa korzysta również z tzw. narzędzi śledzących pomagających dostosować do zainteresowań
            użytkowników wyświetlane reklamy. Dzięki tym narzędziom możemy wyświetlać lub ustawić do wyświetlania na
            naszych stronach poszczególne reklamy, które zostały wybrane (automatycznie) zgodnie z obszarem
            zainteresowań osób odwiedzających. Tracking reklam odbywa się z reguły za pomocą ID reklamowych, przez
            które, m.in. za pomocą plików cookies, dostawca sieci reklamowych tworzy profile użytkowników. Podczas
            otwierania strony internetowej, na podstawie profili cookies, zostaje włączona reklama. Przez użycie tzw.
            tracking pixeli na różnych stronach internetowych, przy pierwszej wizycie użytkownika na stronie partnera
            afiliacyjnego, pliki cookies są zapisywane na urządzeniu końcowym przez partnera afiliacyjnego. Za pomocą
            takiej kampanii remarketingowej użytkownik może być „śledzony” w internecie i mogą mu zostać pokazane
            szczególnie dla niego interesujące oferty. W wielu przypadkach tracking odbywa się za pomocą tzw. odcisków
            palców w przeglądarce, które używają informacji takich jak ustawienia rozdzielczości ekranu użytkownika,
            głębia koloru, strefa czasowa oraz zainstalowane wtyczki, w celu rozpoznania użytkownika bądź grup
            użytkowników.
          </p>
          <p>
            Poprzez tzw. sieci afiliacyjne reklamujemy nasze produkty na stronach internetowych stron trzecich. Klikając
            na reklamę, użytkownik zostaje przekierowany do naszej oferty handlowej. Strona trzecia otrzyma
            identyfikator zamówienia w celach rozliczenia prowizji tylko wtedy, jeśli skorzystasz z usługi.
          </p>
          <p>
            Za pomocą narzędzi śledzących możemy stworzyć lepszą ofertę dla partnerów, osób odwiedzających oraz stron
            zainteresowanych. Narzędzia śledzące oraz powiązane kampanie reklamowe umożliwiają nam bądź stronom trzecim
            monetyzację ruchu z serwisu przy użyciu reklam. Dodatkowo zachowanie użytkownika pozwala nam określić, które
            obszary naszej strony internetowej cieszą się największą popularnością wśród odwiedzających, dzięki czemu
            możemy odpowiednio dopasować reklamy. W rezultacie, narzędzia trackingowe mogą zebrać informacje dotyczące
            tego, skąd pochodzą odwiedzający oraz które obszary strony internetowej odwiedzali, a także jak często i jak
            długo oglądali poszczególne podstrony i kategorie. Często stosowanym zabiegiem reklamowym są kampanie
            retargetingowe i remarketingowe, podczas których użytkownicy są adresowani w innym czasie i innym miejscu w
            internecie, np. poprzez wyświetlanie produktów, które użytkownik oglądał wcześniej na innych stronach
            internetowych bądź takich produktów, które mogłyby go zainteresować.
          </p>
          <p>
            Następujący dostawcy narzędzi do statystyk stron internetowych przetwarzają dane dostępu w naszym imieniu
            dla przeprowadzenia badań zachowań użytkowników oraz stworzenia spersonalizowanej reklamy. W tym celu
            zawarliśmy z dostawcami umowę powierzenia przetwarzania danych osobowych.
          </p>
          <p>
            Szczegóły i dalsze informacje dotyczące dostawców tego typu narzędzi znajdują się w zakładce dotyczącej
            prawa do wniesienia sprzeciwu wobec przetwarzania danych osobowych.
          </p>
          <p>
            Mimo naszych starań, może okazać się, że poniższa lista nie jest kompletna i nie wskazuje wszystkich
            Zaufanych Partnerów Spółki. Wynika to, z tego, że część naszych Zaufanych Partnerów korzysta ze swoich
            podwykonawców albo zleca umieszczenie reklamy na naszej powierzchni reklamowej za pośrednictwem innego
            Zaufanego Partnera, którym jest np. dom mediowy czy sieć reklamowa.
          </p>
        </StyledDiv>
        <StyledDiv>
          <table>
            <thead>
              <tr>
                <th>Dostawca</th>
                <th>Narzędzie</th>
                <th>Dane dostawcy & polityka prywatności</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div>Facebook, Inc.</div>
                  <div>1601 South California Avenue</div>
                  <div>Palo Alto</div>
                  <div>CA 94304</div>
                  <div>USA</div>
                </td>
                <td>Facebook Connect</td>
                <td>
                  <div>
                    <a href="https://www.facebook.com/about/privacy/">https://www.facebook.com/about/privacy/</a>
                  </div>
                  <div>
                    <a href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen">
                      https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Facebook, Inc.</div>
                  <div>1601 South California Avenue</div>
                  <div>Palo Alto</div>
                  <div>CA 94304</div>
                  <div>USA</div>
                </td>
                <td>
                  <div>Facebook Custom Audiences</div>
                  <div>Facebook Pixel</div>
                </td>
                <td>
                  <div>
                    <a href="https://www.facebook.com/about/privacy/">https://www.facebook.com/about/privacy/</a>
                  </div>
                  <div>
                    <a href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen">
                      https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div>Google Inc(Google)</div>
                  <div>1600 Amphitheatre Parkway</div>
                  <div>Mountain View</div>
                  <div>CA 94043</div>
                  <div>USA</div>
                </td>
                <td>
                  <div>Google AdWords User Lists</div>
                  <div>Google Dynamic Remarketing</div>
                  <div>Google Analytics Audiences</div>
                </td>
                <td>
                  <div>
                    <a href="https://www.google.com/policies/technologies/ads/">
                      https:/www.google.com/policies/technologies/ads/
                    </a>
                  </div>
                  <div>
                    <a href="https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active">
                      Privacy shield
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <b>Okres przechowywania danych: </b>
            Szczegóły dotyczące plików cookies, zastosowanych w narzędziach śledzących technologii, okresu
            przechowywania oraz informacje o postępowaniu w celu usunięcia plików cookies znajdują się w zakładce
            dotyczącej cookies w dalszej części dokumentu
          </p>
          <p>
            <b>Podstawa prawna: </b>
            Art. 6 ust. 1 lit. f) ROD
          </p>
          <p>
            <b>Ustawowy bądź umowny wymóg podania danych osobowych: </b>
            Podanie ww. danych osobowych nie jest wymogiem ustawowym ani umownym.
          </p>
          <p>
            <b>Profilowanie </b>
            za pomocą narzędzi śledzących możemy ocenić i przeanalizować obszar zainteresowań oraz zachowanie
            użytkowników naszej strony internetowej. W tym celu my bądź nasz partner tworzymy pseudonimowy profil
            użytkownika.
          </p>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>
            Odwiedzanie https://trustmate.io - zaproszenia, maile, korespondencja, obsługa kont, czat, panel klienta
          </h2>
          <p>
            Będziemy przetwarzać dane: adres e-mail, tytuł, imię, adres firmy, adres rachunku, dane dot. płatności, dane
            logowania zarejestrowanych użytkowników, numer klienta, numer zamówienia (dot. zarejestrowanych
            użytkowników), adres IP, pliki cookies.
          </p>
          <p>
            Przetwarzanie tych danych odbędzie się w celu umożliwienia świadczenia usługi drogą elektroniczną,
            całkowitego korzystania z portalu TrustMate.io wraz z podstronami oraz zapobieganiu problemów technicznych
            związanych z usługami TrustMate SA. Dzięki plikom cookie będziemy w stanie obsługiwać rozmowy z obsługą
            klienta przez czat, zapamiętywać sesję użytkownika i przywracać go do czatu w razie porzucenia. Dodatkowo
            będziemy kontaktować się w sprawie obsługi wniosków, informowania o świadczonej usłudze i
            funkcjonalnościach.
          </p>
          <p>
            Przetwarzamy i usuwamy potwierdzenia zamówień subskrypcji, zgodnie z okresem przechowywania, regulowanym
            prawem podatkowym i handlowym, chyba że udzieliłeś/-aś nam pozwolenia do dłuższego ich użytkowania.
          </p>
          <p>
            Jeśli współpracujesz z TrustMate, dane dodatkowo przechowywane są przez okres, przez który konto jest
            aktywne. Usunięcie konta jest możliwe w każdej chwili i może nastąpić na podstawie pisemnej prośby
            przesłanej na adres <Email email={BOK_EMAIL} setVisible={setShow} visible={show} />
            lub {COMPANY_NAME}, {COMPANY_STREET}, {COMPANY_ZIP_CODE}.
          </p>
          <p>
            W zależności od wybranych metod płatności dane o Twoje płatności zostaną przekazane do odpowiedniego
            dostawcy usług płatniczych. Odpowiedzialność za dane o Twoich płatnościach spoczywa na dostawcy usług
            płatniczych.
          </p>
          <p>Bez podania powyższych danych niemożliwe jest świadczenie usług przez {COMPANY_NAME}.</p>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Logowanie https://trustmate.io - facebook, google, mail</h2>
        </StyledDiv>
        <StyledDiv>
          <p>
            Facebook Connect jest serwisem, który umożliwia użytkownikom sieci społecznej Facebook logowanie się na
            naszej stronie internetowej oraz dodawanie opinii bez akceptacji mailowej za pomocą profilu sieci Facebook,
            bez potrzeby tworzenia osobnego konta. Aby korzystać z wtyczki Facebook Connect użytkownik musi posiadać
            konto w serwisie Facebook. Używając Facebook Connect, co najmniej pełne imię użytkownika będzie połączone z
            naszym kontem. Więcej informacji wyświetli się użytkownikowi w okienku. Nie mamy wpływu na zbieranie danych,
            na cel ich przetwarzania ani na okres ich przechowywania. Nie posiadamy również żadnych informacji
            dotyczących usuwania danych zbieranych przez dostawcę wtyczki. Do serwisu społecznościowego przesyłamy dane
            logowania oraz Twój adres IP.
          </p>
          <p>
            Konto Google jest serwisem, który umożliwia użytkownikom operatora mailowego Google logowanie się na naszej
            stronie internetowej oraz dodawanie opinii bez akceptacji mailowej za pomocą konta mailowego Google, bez
            potrzeby tworzenia osobnego konta. Aby korzystać z wtyczki Google użytkownik musi posiadać konto e-mail w
            serwisie Google. Używając logowania za pomocą Google, co najmniej pełne imię użytkownika będzie połączone z
            naszym kontem. Więcej informacji wyświetli się użytkownikowi w okienku. Nie mamy wpływu na zbieranie danych,
            na cel ich przetwarzania ani na okres ich przechowywania.
          </p>
          <p>
            Jeśli zarejestrujesz się używając wtyczki Facebook Connect lub konta Google klikając w przycisk jasno
            świadczący o fakcie logowania z wykorzystaniem jednego z powyższych rozwiązań zostaniesz automatycznie
            przeniesiony do operatora oferującego rozwiązania wybranego przez Ciebie. Tam możesz się zalogować za pomocą
            swoich danych logowania. Po udanej weryfikacji, zostanie utworzone połączenie między kontem Google lub
            Facebooka (zależy od wyboru) a naszą stroną internetową, przez które będą przesyłane dane.
          </p>
          <p>
            Dzięki temu rozwiązaniu możesz korzystać z naszej strony internetowej bez tworzenia osobnego konta ze swoimi
            danymi.
          </p>
          <p>
            W przypadku, gdy nie zdecydujesz się na rejestracje przy użyciu powyższych rozwiązań dajemy możliwość
            stworzenia konta klienta za pomocą rejestracji przez adres e-mail.
          </p>
        </StyledDiv>
      </StyledDiv>
      <StyledDiv>
        <StyledDiv>
          <h2>Pliki cookies</h2>
        </StyledDiv>
        <StyledDiv>
          <h3>Co to są pliki cookies?</h3>
          <p>
            Pliki cookies to małe pliki tekstowe zapisywane na komputerze lub urządzeniu przenośnym podczas wizyty
            użytkownika na danej stronie internetowej. Dla wygody, używany tu termin “pliki cookies” obejmuje techniki,
            jak: pliki cookies, cookies flash i sygnalizatory www. Nie zajmują one dużo miejsca i są usuwane
            automatycznie po wygaśnięciu. Niektóre pliki cookies wygasają po zakończeniu się sesji użytkownika, podczas
            gdy inne są zapisywane na pewien czas. Pliki cookies pomagają również w zapewnieniu usług na naszej stronie
            internetowej, spersonalizowaniu treści oraz dostosowaniu i analizie reklam.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Jakich plików cookies używamy?</h3>
          <p>Dzielimy pliki cookies na pięć kategorii w zależności od ich przeznaczenia i pełnionej funkcji:</p>
          <ol>
            <li>
              Używamy <b>„niezbędnych” plików cookies</b> w naszym serwisie, abyś mógł/mogła poruszać się po naszej
              stronie i korzystać z jej podstawowych funkcji.
            </li>
            <li>
              Używamy <b>„wydajnościowych” plików cookies</b>, w celu usprawnienia korzystania z naszej strony
              internetowej. Pliki te zbierają informacje o sposobie korzystania z naszych stron internetowych, np. o
              przeglądarce internetowej i systemie operacyjnym, z którego użytkownik korzysta, nazwie domeny strony
              internetowej, z której trafiłeś/trafiłaś na nasz serwis, liczbie wizyt, średnim czasie wizyty oraz
              otwieranych stronach.
            </li>
            <li>
              Używamy <b>„analitycznych” plików cookies</b>, aby nasz serwis był bardziej przyjazny użytkownikowi.
              Dzięki tym plikom możemy ustalić, jak użytkownicy korzystają z naszej strony oraz np. na podstawie jakich
              preferencji i fraz wyszukiwania została otworzona nasza strona internetowa.
            </li>
            <li>
              Używamy <b>„reklamowych” plików cookies</b>, aby zapewnić Ci dostosowaną do Twoich potrzeb treść.
              Reklamowe pliki cookies stosowane są również do pomiaru i kontrolowania skuteczności kampanii reklamowych.
              Marketingowe pliki cookies rejestrują, czy dana strona internetowa jest odwiedzana i jakie treści są
              wykorzystywane. Te informacje mogą być również przekazywane podmiotom zewnętrznym, np. reklamodawcom, i są
              często połączone z funkcjami strony internetowej tych podmiotów (pliki cookies stron trzecich).
            </li>
            <li>
              <b>„Społecznościowe” pliki cookies</b> stosowane są przez portale społecznościowe, np. dane logowania do
              portalu społecznościowego mogą być wykorzystane do rejestracji na naszej stronie internetowej lub
              korzystania z czatu.
            </li>
          </ol>
        </StyledDiv>
        <StyledDiv>
          <h3>Po co używamy plików cookies?</h3>
          <p>
            {COMPANY_NAME} stosuje pliki cookies przede wszystkim w celu zapewnienia satysfakcji użytkowników z wizyt na
            naszej stronie internetowej, jak również do celów reklamowych podczas przyszłych wizyt na innych stronach
            internetowych oraz prowadzenia analityki serwisu.
          </p>
        </StyledDiv>
        <div className="row d-block">
          <h3>Co mogę zrobić, JEŚLI NIE LUBIĘ PLIKÓW COOKIES?</h3>
          <p>
            Użytkownik może zmienić ustawienia przeglądarki, aby usunąć lub nie dopuszczać do przechowywania niektórych
            plików cookies na komputerze lub urządzeniu mobilnym bez wyraźnej zgody użytkownika. Informacje na temat
            zarządzania ustawieniami plików cookies zamieszczono w sekcji “Pomoc”. Dowiedz się, jak to działa w Twojej
            przeglądarce, klikając tutaj:
          </p>
          <p>
            <b>Internet Explorer:</b>{' '}
            https://support.microsoft.com/help/17442/windows-internet-explorer-delete-manage-cookies
          </p>
          <p>
            <b>Mozilla Firefox:</b> http://support.mozilla.com/en-US/kb/Cookies
          </p>
          <p>
            <b>Google Chrome:</b> http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647
          </p>
          <p>
            <b>Safari:</b> http://support.apple.com/kb/PH5042
          </p>
          <p>
            <b>Opera:</b> http://www.opera.com/browser/tutorials/security/privacy/
          </p>
          <p>
            <b>Adobe (pliki cookies flash:)</b> http://www.adobe.com/privacy/policies/flash-player.html
          </p>
          <p>
            Możesz również zapobiegać automatycznemu ładowaniu się tzw. skryptów. Dodatek NoScript pozwala na
            wykonywanie skryptów JavaScript, apletów Java oraz innych wtyczek jedynie przez zaufane domeny wybrane przez
            użytkownika. Informacje i instrukcje dotyczące korzystania z tej funkcji znajdziesz na stronach dostawców
            przeglądarek.
          </p>
        </div>
        <StyledDiv>
          <h3>Jak często ma miejsce aktualizacja oświadczenia dotyczącego plików cookies?</h3>
          <p>
            Niniejsze oświadczenie dotyczące plików cookies może być okresowo aktualizowane w celu odzwierciedlenia np.
            zmian w stosowanych przez nas plikach cookies lub z innych przyczyn operacyjnych, prawnych lub
            regulacyjnych. Należy więc regularnie wracać do tych informacji na temat plików cookies, aby posiadać
            aktualne informacje o stosowaniu plików cookies i rozwiązań pokrewnych. W górnej części niniejszego
            oświadczenia dotyczącego plików cookies widnieje data ostatniej aktualizacji.
          </p>
        </StyledDiv>
        <StyledDiv>
          <h3>Gdzie można uzyskać więcej informacji?</h3>
          <p>
            Pytania dotyczące stosowanych przez nas plików cookies lub innych rozwiązań można przesyłać pod adresem{' '}
            <Email email={RODO_EMAIL} setVisible={setShow} visible={show} />.
          </p>
        </StyledDiv>
        <StyledDiv>
          <p>Data ostatniej aktualizacji: {PRIVACY_POLICY_LAST_UPDATE}.</p>
        </StyledDiv>
      </StyledDiv>
    </>
  );
}

export default PrivacyPolicyPl;
